import '../Style/CSS/CounterApp.min.css';
import {useState} from 'react';
import PrimaryButton from "../../Shared/Components/PrimaryButton";
import SuccessButton from "../../Shared/Components/SuccessButton";
import DangerButton from "../../Shared/Components/DangerButton";

export default function CounterApp() {

	const [counter, setCounter] = useState(0);

	function increment() {
		setCounter(counter + 1);
	}

	function reset() {
		setCounter(0);
	}

	function decrement() {
		setCounter(counter - 1);
	}

	let color = "#ffffff";
	if(counter >= 1) {
		color = "#198754";
	} else if(counter <= -1) {
		color = "#dc3545";
	} else {
		color = "#ffffff";
	}

	return (
		<>
			<hr />
			<div className="pb-5">
				<div className="bg-dark w-50 m-auto mt-5 pt-5 rounded-3">
					<h2 className="text-center mb-5">Native ReactJS Counter Web Application</h2>
					<div className="counter-bg"><span style={{color: color, fontWeight: "bolder"}}>{counter}</span></div>
					<div>
						<SuccessButton buttonText={"Increment"} clickHandler={increment}></SuccessButton>
						<PrimaryButton buttonText={"Reset"} clickHandler={reset}></PrimaryButton>
						<DangerButton buttonText={"Decrement"} clickHandler={decrement}></DangerButton>
					</div>
				</div>
			</div>
		</>
	);
}